import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef, useMemo, useCallback } from 'react';
import c from 'classnames';
import Input from '../../Input/index.js';
import Autocomplete from '../Autocomplete/index.js';
import { selectStyles } from './styles.js';

var _excluded = ["multiple", "blurOnSelect", "className", "disableCloseOnSelect", "isOptionEqualToValue", "onChange", "options", "renderValue", "value"];
var Select = function Select(props, ref) {
  var multiple = props.multiple,
    _props$blurOnSelect = props.blurOnSelect,
    blurOnSelect = _props$blurOnSelect === void 0 ? !multiple : _props$blurOnSelect,
    className = props.className,
    _props$disableCloseOn = props.disableCloseOnSelect,
    disableCloseOnSelect = _props$disableCloseOn === void 0 ? multiple : _props$disableCloseOn,
    isOptionEqualToValueProp = props.isOptionEqualToValue,
    onChangeProp = props.onChange,
    options = props.options,
    renderValue = props.renderValue,
    valueProp = props.value,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var value = useMemo(function () {
    if (Array.isArray(valueProp)) {
      return options.filter(function (option) {
        return valueProp.includes(option.value);
      });
    }
    if (valueProp) {
      return options.find(function (option) {
        return option.value === valueProp;
      });
    }
    return valueProp || null;
  }, [options, valueProp]);
  var onChange = useCallback(function (_, nextValue) {
    var updatedValue = null;
    if (Array.isArray(nextValue)) {
      updatedValue = nextValue.map(function (selectValue) {
        return selectValue.value;
      });
    } else if (nextValue != null && nextValue.value) {
      updatedValue = nextValue.value;
    }
    onChangeProp == null ? void 0 : onChangeProp(updatedValue, nextValue);
  }, [onChangeProp]);
  var getRenderInputParams = useCallback(function (params) {
    if (!multiple && value && renderValue) {
      params.inputProps = _extends({}, params.inputProps, {
        value: ''
      });
      params.startAdornment = renderValue(value);
      params.placeholder = '';
    }
    return params;
  }, [multiple, renderValue, value]);
  var renderInput = function renderInput(_params) {
    var params = getRenderInputParams(_params);
    return /*#__PURE__*/React__default.createElement(Input, _extends({}, params, {
      readOnly: true
    }));
  };
  var isOptionEqualToValue = useCallback(function (option, value) {
    if (isOptionEqualToValueProp) {
      return isOptionEqualToValueProp(option, value);
    }
    return option.value === value.value;
  }, [isOptionEqualToValueProp]);
  return /*#__PURE__*/React__default.createElement(Autocomplete, _extends({
    ref: ref,
    blurOnSelect: blurOnSelect,
    className: c(selectStyles, className),
    disableCloseOnSelect: disableCloseOnSelect,
    isOptionEqualToValue: isOptionEqualToValue,
    multiple: multiple,
    options: options,
    renderInput: renderInput,
    value: value,
    onChange: onChange
  }, rest));
};
var index = /*#__PURE__*/React__default.memo( /*#__PURE__*/forwardRef(Select));

export { index as default };
//# sourceMappingURL=index.js.map
